import script from "./PlatformTypeFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformTypeFilter.vue?vue&type=script&setup=true&lang=js"

import "./PlatformTypeFilter.vue?vue&type=style&index=0&id=41c0ce53&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c0ce53"]])

export default __exports__